import type { ReactNode } from "react";
import type { Item } from "@/shared/components/generic/items.ts";
import type { DurationDisplayUnit } from "@/pages/human-resources/time-management/model/display-options/DurationDisplayUnit.ts";
import useDisplayOptionsState from "@/pages/human-resources/time-management/model/display-options/useDisplayOptionsState.ts";
import useDisplayOptionsDispatch from "@/pages/human-resources/time-management/model/display-options/useDisplayOptionsDispatch.ts";
import { useTranslation } from "react-i18next";
import FlatSelect from "@/pages/human-resources/time-management/schedules/site-schedule/toolbar/display-options/menu/flat-select/FlatSelect.tsx";

export default function TimeUnits(): ReactNode {
  const { t } = useTranslation(["humanResources"], {
    keyPrefix: "timeManagement.scheduleDisplayOptions.durationDisplayUnit",
  });
  const units: DurationDisplayUnit[] = ["MINUTE", "HUNDREDTH"];
  const items: Item<DurationDisplayUnit>[] = units.map((u) => ({
    key: u,
    label: t(u.toLowerCase()),
    data: u,
  }));
  const { durationUnit } = useDisplayOptionsState();
  const { dispatch } = useDisplayOptionsDispatch();
  return (
    <FlatSelect
      title={t("title")}
      items={items}
      selectedItem={items.find((i) => i.data === durationUnit)}
      onSelectItem={(item) => {
        dispatch({
          type: "setDurationUnit",
          unit: item.data ?? "MINUTE",
        });
      }}
    />
  );
}
